import React, { Component } from "react";
import ReactDOM from "react-dom";
import $ from "jquery";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import { history } from "../helper/History";
import Carousel from "react-bootstrap/Carousel";
import ScrollIntoView from "react-scroll-into-view";

class talentCompy extends Component {
  constructor(props) {
    super(props);

    window.scrollTo(0, 0); // scroll page to top

  }
  componentDidMount() {

    // scroll to footer if route has hash
    if (window.location.hash === "#unique") {
      const el = document.getElementById("unique");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  }

  setBigGroup() {

    // localStorage.setItem("redirectpage","Consultant")
    localStorage.removeItem("alert2")
    localStorage.removeItem("alert8");
    localStorage.removeItem("alert9");
    localStorage.removeItem("alert11");

    localStorage.setItem("alert9", "1");
  }

  buyNowTest() {
    $(".pilotModal").modal("hide");
    localStorage.setItem("testType", "professional"); // set testtyle to localstorage
    history.push("/buy-test");
  }
  openHappiness() {
    var userType = localStorage.getItem("userRole");
    if (userType === "Enterprise") {
      $(".pilotModal").modal("hide");
      localStorage.setItem("testType", "professional"); // set testtype to localstorage
      history.push("/happiness");
    } else {
      const title =
        this.props.lang === "en"
          ? "ACCESS ONLY FOR PROFESSIONAL"
          : "ACCES POUR PROFESSIONNEL UNIQUEMENT";
      const errorMsg =
        this.props.lang === "en"
          ? "Sorry this part of the presentation is accessible only by Enterprise"
          : "Désolé cette partie de la plateforme est réservée aux Enterprise. Si vous êtes un professionnel, enregistrez-vous.";
      $("#happiness").modal("hide");
      $("#errorModal .modal-title").text(title);
      $(".modal-body #errorTxt").text(errorMsg);
      $("#errorModal").modal("show");
    }
  }

  openSale() {
    var userType = localStorage.getItem("userRole");
    if (userType === "Enterprise") {
      $(".pilotModal").modal("hide");
      localStorage.setItem("testType", "professional"); // set testtype to localstorage
      history.push("/sale");
    } else {
      const title =
        this.props.lang === "en"
          ? "ACCESS ONLY FOR PROFESSIONAL"
          : "ACCES POUR PROFESSIONNEL UNIQUEMENT";
      const errorMsg =
        this.props.lang === "en"
          ? "Sorry this part of the presentation is accessible only by Enterprise"
          : "Désolé cette partie de la plateforme est réservée aux Enterprise. Si vous êtes un professionnel, enregistrez-vous.";
      $("#sale").modal("hide");
      $("#errorModal .modal-title").text(title);
      $(".modal-body #errorTxt").text(errorMsg);
      $("#errorModal").modal("show");
    }
  }

  openBusinessCreation() {
    var userType = localStorage.getItem("userRole");
    if (userType === "Enterprise") {
      $(".pilotModal").modal("hide");
      localStorage.setItem("testType", "professional"); // set testtype to localstorage
      history.push("/business-creation");
    } else {
      const title =
        this.props.lang === "en"
          ? "ACCESS ONLY FOR PROFESSIONAL"
          : "ACCES POUR PROFESSIONNEL UNIQUEMENT";
      const errorMsg =
        this.props.lang === "en"
          ? "Sorry this part of the presentation is accessible only by Enterprise"
          : "Désolé cette partie de la plateforme est réservée aux Enterprise. Si vous êtes un professionnel, enregistrez-vous.";
      $("#target").modal("hide");
      $("#errorModal .modal-title").text(title);
      $(".modal-body #errorTxt").text(errorMsg);
      $("#errorModal").modal("show");
    }
  }

  openRecruitment() {
    var userType = localStorage.getItem("userRole");
    if (userType === "Enterprise") {
      $(".pilotModal").modal("hide");
      localStorage.setItem("testType", "professional"); // set testtype to localstorage
      history.push("/recruitment");
    } else {
      const title =
        this.props.lang == "en"
          ? "ACCESS ONLY FOR PROFESSIONAL"
          : "ACCES POUR PROFESSIONNEL UNIQUEMENT";
      const errorMsg =
        this.props.lang == "en"
          ? "Sorry this part of the presentation is accessible only by Enterprise"
          : "Désolé cette partie de la plateforme est réservée aux Enterprise. Si vous êtes un professionnel, enregistrez-vous.";
      $("#RECRUITMENT").modal("hide");
      $("#errorModal .modal-title").text(title);
      $(".modal-body #errorTxt").text(errorMsg);
      $("#errorModal").modal("show");
    }
  }

  openCoachingCareer() {
    var userType = localStorage.getItem("userRole");
    if (userType === "Enterprise") {
      $(".pilotModal").modal("hide");
      localStorage.setItem("testType", "professional"); // set testtype to localstorage
      history.push("/coaching-career");
    } else {
      const title =
        this.props.lang === "en"
          ? "ACCESS ONLY FOR PROFESSIONAL"
          : "ACCES POUR PROFESSIONNEL UNIQUEMENT";
      const errorMsg =
        this.props.lang === "en"
          ? "Sorry this part of the presentation is accessible only by Enterprise"
          : "Désolé cette partie de la plateforme est réservée aux Enterprise. Si vous êtes un professionnel, enregistrez-vous.";
      $("#talent").modal("hide");
      $("#errorModal .modal-title").text(title);
      $(".modal-body #errorTxt").text(errorMsg);
      $("#errorModal").modal("show");
    }
  }

  // open exmplease function
  openHappinessExamples() {
    let lang = this.props.lang;
    var userType = localStorage.getItem("userRole");
    $(".pilotModal").modal("hide");
    //console.log('loggedIn '+this.props.isSignedIn);
    if (this.props.isSignedIn === null || !this.props.isSignedIn) {
      // $("#loginModal").modal("show");
      history.push("/login");
    } else if (this.props.isSignedIn) {
      if (userType === "Enterprise") {
        const startButtonText =
          this.props.lang === "en"
            ? "Start Happiness Tool"
            : "Démarrer Happiness Tool";
        $("#testResultData").attr(
          "src",
          "assets/images/professionalHappinessResult_" + lang + ".png"
        );
        //$("#exampleResultTitle").text("Happiness Tools Results"); // added title
        // Add start button below examples
        const happinessButton = (
          <div>
            <div>
              <button
                onClick={this.openHappiness.bind(this)}
                className="btn btn-warning center-block"
              >
                {startButtonText}
                <br />
              </button>
            </div>
            <div>
              <button
                type="button"
                className="close btn  center-block"
                style={{}}
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        );

        ReactDOM.render(
          happinessButton,
          document.getElementById("startButton")
        );
        $("#myModal").modal("show");
      } else {
        const title =
          this.props.lang === "en"
            ? "ACCESS ONLY FOR PROFESSIONAL"
            : "ACCES POUR PROFESSIONNEL UNIQUEMENT";
        const errorMsg =
          this.props.lang === "en"
            ? "Sorry this part of the presentation is accessible only by Enterprise"
            : "Désolé cette partie de la plateforme est réservée aux Enterprise. Si vous êtes un professionnel, enregistrez-vous.";
        $("#happiness").modal("hide");
        $("#errorModal .modal-title").text(title);
        $(".modal-body #errorTxt").text(errorMsg);
        $("#errorModal").modal("show");
      }
    }
  }
  setEnterprise() {
    localStorage.setItem("redirectpage", "Enterprise")
  }
  openSaleExamples() {
    let lang = this.props.lang;
    var userType = localStorage.getItem("userRole");
    $(".pilotModal").modal("hide");
    if (this.props.isSignedIn === null || !this.props.isSignedIn) {
      // $("#loginModal").modal("show");
      history.push("/login");
    } else if (this.props.isSignedIn) {
      if (userType === "Enterprise") {
        const startButtonText =
          this.props.lang === "en" ? "Start Sales Tool" : "Démarrer Sales Tool";
        $("#testResultData").attr(
          "src",
          "assets/images/professionalSaleResult_" + lang + ".png"
        );
        //$("#exampleResultTitle").text("Sale Tools Results"); // added title
        // Add start button below examples
        const SaleButton = (
          <div>
            <div>
              <button
                onClick={this.openSale.bind(this)}
                className="btn btn-warning center-block"
              >
                {startButtonText}
                <br />
              </button>
            </div>
            <div>
              <button
                type="button"
                className="close btn  center-block"
                style={{}}
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        );
        ReactDOM.render(SaleButton, document.getElementById("startButton"));
        $("#myModal").modal("show");
      } else {
        const title =
          this.props.lang === "en"
            ? "ACCESS ONLY FOR PROFESSIONAL"
            : "ACCES POUR PROFESSIONNEL UNIQUEMENT";
        const errorMsg =
          this.props.lang === "en"
            ? "Sorry this part of the presentation is accessible only by Enterprise"
            : "Désolé cette partie de la plateforme est réservée aux Enterprise. Si vous êtes un professionnel, enregistrez-vous.";
        $("#sale").modal("hide");
        $("#errorModal .modal-title").text(title);
        $(".modal-body #errorTxt").text(errorMsg);
        $("#errorModal").modal("show");
      }
    }
  }

  openBusinessCreationExamples() {
    let lang = this.props.lang;
    var userType = localStorage.getItem("userRole");
    $(".pilotModal").modal("hide");
    if (this.props.isSignedIn === null || !this.props.isSignedIn) {
      // $("#loginModal").modal("show");
      history.push("/login");
    } else if (this.props.isSignedIn) {
      if (userType === "Enterprise") {
        const startButtonText =
          this.props.lang === "en"
            ? "Start Business creation tool"
            : "Démarrer Business creation tool";
        $("#testResultData").attr(
          "src",
          "assets/images/professionailBussinessCreation_" + lang + ".png"
        );
        //$("#exampleResultTitle").text("Business Creation Tools Results"); // added title
        // Add start button below examples
        const businessCreationButton = (
          <div>
            <div>
              <button
                onClick={this.openBusinessCreation.bind(this)}
                className="btn btn-warning center-block"
              >
                {startButtonText}
                <br />
              </button>
            </div>
            <div>
              <button
                type="button"
                className="close btn  center-block"
                style={{}}
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        );
        ReactDOM.render(
          businessCreationButton,
          document.getElementById("startButton")
        );
        $("#myModal").modal("show");
      } else {
        const title =
          this.props.lang === "en"
            ? "ACCESS ONLY FOR PROFESSIONAL"
            : "ACCES POUR PROFESSIONNEL UNIQUEMENT";
        const errorMsg =
          this.props.lang === "en"
            ? "Sorry this part of the presentation is accessible only by Enterprise"
            : "Désolé cette partie de la plateforme est réservée aux Enterprise. Si vous êtes un professionnel, enregistrez-vous.";
        $("#target").modal("hide");
        $("#errorModal .modal-title").text(title);
        $(".modal-body #errorTxt").text(errorMsg);
        $("#errorModal").modal("show");
      }
    }
  }

  openRecruitmentExamples() {
    let lang = this.props.lang;
    var userType = localStorage.getItem("userRole");
    $(".pilotModal").modal("hide");
    if (this.props.isSignedIn === null || !this.props.isSignedIn) {
      // $("#loginModal").modal("show");
      history.push("/login");
    } else if (this.props.isSignedIn) {
      if (userType === "Enterprise") {
        const startButtonText =
          this.props.lang === "en"
            ? "Start Recruitment tool"
            : "Démarrer Recruitment tool";
        $("#testResultData").attr(
          "src",
          "assets/images/recruitment_" + lang + ".png"
        );
        //$("#exampleResultTitle").text("Recruitment Tool Results"); // added title
        // Add start button below examples
        const recruitmentButton = (
          <div>
            <div>
              <button
                onClick={this.openRecruitment.bind(this)}
                className="btn btn-warning center-block"
              >
                {startButtonText}
                <br />
              </button>
            </div>
            <div>
              <button
                type="button"
                className="close btn  center-block"
                style={{}}
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        );
        ReactDOM.render(
          recruitmentButton,
          document.getElementById("startButton")
        );
        $("#myModal").modal("show");
      } else {
        const title =
          this.props.lang === "en"
            ? "ACCESS ONLY FOR PROFESSIONAL"
            : "ACCES POUR PROFESSIONNEL UNIQUEMENT";
        const errorMsg =
          this.props.lang === "en"
            ? "Sorry this part of the presentation is accessible only by Enterprise"
            : "Désolé cette partie de la plateforme est réservée aux Enterprise. Si vous êtes un professionnel, enregistrez-vous.";
        $("#RECRUITMENT").modal("hide");
        $("#errorModal .modal-title").text(title);
        $(".modal-body #errorTxt").text(errorMsg);
        $("#errorModal").modal("show");
      }
    }
  }

  openCoachingCareerExamples() {
    let lang = this.props.lang;
    var userType = localStorage.getItem("userRole");
    $(".pilotModal").modal("hide");
    if (this.props.isSignedIn === null || !this.props.isSignedIn) {
      // $("#loginModal").modal("show");
      history.push("/login");
    } else if (this.props.isSignedIn) {
      if (userType === "Enterprise") {
        const startButtonText =
          this.props.lang === "en"
            ? "Start Coaching tool"
            : "Démarrer Coaching tool";
        $("#testResultData").attr(
          "src",
          "assets/images/professionalCoachingCareerResult_" + lang + ".png"
        );
        //$("#exampleResultTitle").text("Coaching Tool Results"); // added title
        // Add start button below examples
        const coachingCareerButton = (
          <div>
            <div>
              <button
                onClick={this.openCoachingCareer.bind(this)}
                className="btn btn-warning center-block"
              >
                {startButtonText}
                <br />
              </button>
            </div>
            <div>
              <button
                type="button"
                className="close btn  center-block"
                style={{}}
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        );
        ReactDOM.render(
          coachingCareerButton,
          document.getElementById("startButton")
        );
        $("#myModal").modal("show");
      } else {
        const title =
          this.props.lang === "en"
            ? "ACCESS ONLY FOR PROFESSIONAL"
            : "ACCES POUR PROFESSIONNEL UNIQUEMENT";
        const errorMsg =
          this.props.lang === "en"
            ? "Sorry this part of the presentation is accessible only by Enterprise"
            : "Désolé cette partie de la plateforme est réservée aux Enterprise. Si vous êtes un professionnel, enregistrez-vous.";
        $("#talent").modal("hide");
        $("#errorModal .modal-title").text(title);
        $(".modal-body #errorTxt").text(errorMsg);
        $("#errorModal").modal("show");
      }
    }
  }

  showalert2() {
    localStorage.removeItem("alert9", "1");
    localStorage.removeItem("alert2", "4");
    localStorage.setItem("alert2", "3");
  }

  showalert3() {
    localStorage.removeItem("alert9", "1");
     localStorage.removeItem("alert2", "3");
    localStorage.setItem("alert2", "4");
  }



  handleClick() {
    const price = "unique";
    const element = document.getElementById(price);
    console.log(element);
    if (element) {
      // 👇 Will scroll smoothly to the top of the next section

      element.scrollIntoView({ behavior: "smooth" });
    }
  }
  handleButton() {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }


  errMessage() {
    setTimeout(() => {
      // Remove the item from localStorage after the specified time

      localStorage.removeItem('guide');
    }, 400000);

    return (
      <div class="alert alert-success alert-dismissible fade show " role="alert">
        <FormattedHTMLMessage id="alert7" />
        <button type="button" class="close" onClick={(e) => localStorage.removeItem("guide")} data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    )
    setTimeout(() => {
      this.props.clearMessage();
    }, 25000);

  }




  render() {
    let CopyrightDate = new Date();
    const userRole = localStorage.getItem("userRole");
    const navigate = localStorage.getItem("navigation");
    return (
      <React.Fragment>
        <section>

          <div className="col-md-12 d-flex p-0">

            <Carousel id="slider-main" className="individual-slider">
              <Carousel.Item>
                <img
                  className="d-block w-100 bg top-slide object-pos-left"
                  src="/assets/images/flyinglady.jpg"
                  style={{ objectFit: "cover" }}
                  alt="First slide"
                />
                <Carousel.Caption className="text-left d-flex h-100 align-items-center justify-content-center">
                  {localStorage.getItem('guide') == "3" ? this.errMessage() :
                    <div className="intro_layers text-center">
                      {/* <div className="intro_layer mt-3" data-animation="fadeIn">
                      <div className="d-inline-block animate animated bounce">
                        <button
                          type="button"
                          className="btn btn-outline-maincolor center-block"
                          data-animation="fadeIn" data-toggle="modal" data-target="#indivisualContactUs"
                        >
                          ACCESS TO AN EXAMPLE OF PROFILE
                          <br />
                          <div className="small">
                          LEAVE YOUR EMAIL
                          </div>
                        </button>

                      </div>
                    </div>                     */}
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', margin: '0 auto' }}>

                        {/* Top Blue Box */}
                        <div
                          className="intro_layer animate animated fadeFromTop "
                          data-animation="fadeInLeft"
                          style={{
                            backgroundColor: "#18B6CE",
                            color: "white",
                            padding: "20px",
                            width: 'fit-content',
                            maxWidth: '100%',
                            boxSizing: 'border-box',
                            marginBottom: '10px'
                          }}
                        >
                          {/* <h4 className="text-uppercase intro_featured_word mb-2 mt-4"> */}

                          {/* </h4> */}
                          <p className="text-uppercase intro_featured_word mb-2 mt-4">
                            <b>
                              <FormattedHTMLMessage
                                id="talent.compy.heading1"
                                defaultMessage="TESTS FOR INDIVIDUAL"
                              />
                            </b>
                          </p>
                          <p className="text-left mb-0">
                            {" "}
                            <FormattedHTMLMessage
                              id="talent.compy.ul"
                              defaultMessage="12 months"
                            />{" "}
                          </p>
                        </div>

                        {/* Bottom Black Box */}
                        <div
                          className="py-4 px-4 font-weight-bold"
                          style={{
                            width: '100%',
                            maxWidth: '520px',
                            margin: '20px auto 0',
                            display: 'block',
                            boxSizing: 'border-box',
                            textAlign: 'center',
                            backgroundColor: 'rgb(242 242 242)',
                            color: '#040101ff'
                          }}
                        >
                          <span>
                            <FormattedHTMLMessage
                              id="talent.compy.banner.dark.text1"
                              defaultMessage="Become self-reliant with the PILOT RH® platform!"
                            />
                          </span>
                        </div>

                      </div>
                    </div>}
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </div>
         
          <div className="">
             {userRole && (
            <Link to="/youareacompany">
                <div
                className="white-btns-hr consultant-btn mt-3"
                style={{
                  backgroundColor: "#003366",
                  color: "white",
                  
                  borderRadius: "5px"
                }}
              >
                <div>
                  <FormattedHTMLMessage
                     id={userRole === "User" ? "sub.menue" : userRole === "Hr" ? "sub.menue1" : userRole === "Enterprise" ? "sub.menue2" : "sub.menue"}
                    defaultMessage="<p className='pb-1'> €350 VAT included <span className='small'>instead of <del>450 €</del></span></p>"
                  />
                </div>
              </div>
            </Link>
            )}
            <div
              className="white-btn"
              style={{
                backgroundColor: "#003366",
                color: "white",
                border: "none",
                textAlign: "left",
                borderRadius: "5px",
              }}
            >
              <Link
                className="btn btn-primary p-link"
                to="/contact-professional"
                style={{
                  background: "transparent",
                  color: "white",
                  border: "none",
                  textTransform: "none",
                }}
              >
                <FormattedHTMLMessage
                  id="hrsupport.test.btn.content"
                  defaultMessage="€350 VAT included <span>instead of <del>450 €</del></span>"
                />
              </Link>
            </div>

            <ScrollIntoView selector="#unique">
              <Link style={{ color: "white" }} to="#">
                <button
                  className="white-btn"
                  style={{
                    backgroundColor: "#003366",
                    color: "white",
                    border: "none",
                    marginTop: "6%",
                    borderRadius: "5px",
                  }}
                >
                  <FormattedHTMLMessage
                    id="tarifs"
                    defaultMessage="<p className='pb-1'> €350 VAT included <span className='small'>instead of <del>450 €</del></span></p>"
                  />
                </button>
              </Link>
            </ScrollIntoView>
             <Link to={userRole === "Enterprise" ? "/pre-registration" : userRole === "Hr" ? "/training-group" : "#"}>
              <button
                className="white-btn"
                style={{
                  backgroundColor: "#003366",
                  color: "white",
                  border: "none",
                  marginTop: "12%",
                  borderRadius: "5px",
                }}
              >
                <FormattedHTMLMessage
                  id="talent.btn.title"
                  defaultMessage="<p className='pb-1'> €350 VAT included <span className='small'>instead of <del>450 €</del></span></p>"
                />
              </button>
            </Link>
          </div>
        </section>
        <section className="individual-test" id="talent-company">
          <div className="container-fluid p-0">
            <div className="intro_layer" data-animation="fadeIn">
              <div className="d-block">
                <div className="indi-tests" style={{}}>
                  <ul className="services-list" style={{ top: '-80px' }}>
                    <li style={{ backgroundColor: "white", color: "black" }}>
                      <button
                        data-animation="fadeIn"
                        data-toggle="modal"
                        data-target="#happiness"
                        className="btn"
                      >
                        {/* <img src="assets/images/smile-1.png" alt="" /> */}
                        <span style={{ color: "#18B6CE" }}>
                          <FormattedHTMLMessage
                            id="talent.compy.card1"
                            defaultMessage="TOOL"
                          />
                        </span>{" "}
                        <br />
                        <FormattedHTMLMessage
                          id="talent.compy.card1.sub"
                          defaultMessage="TEST"
                        />
                        <p>
                          <FormattedHTMLMessage
                            id="talent.compy.credit1"
                            defaultMessage="1 credit"
                          />
                        </p>
                      </button>
                    </li>
                    <li style={{ backgroundColor: "white", color: "black" }}>
                      <button
                        data-toggle="modal"
                        data-target="#RECRUITMENT"
                        className="btn"
                      >
                        <span style={{ color: "#18B6CE" }}>
                          <FormattedHTMLMessage
                            id="talent.compy.card2"
                            defaultMessage="TOOL"
                          />
                        </span>{" "}
                        <br />
                        <FormattedHTMLMessage
                          id="talent.compy.card2.sub"
                          defaultMessage="TEST"
                        />
                        <p>
                          <FormattedHTMLMessage
                            id="talent.compy.credit2"
                            defaultMessage="3 credits"
                          />
                        </p>
                      </button>
                    </li>
                    <li style={{ backgroundColor: "white", color: "black" }}>
                      <button
                        data-toggle="modal"
                        data-target="#talent"
                        className="btn"
                      >
                        <span style={{ color: "#18B6CE" }}>
                          <FormattedHTMLMessage
                            id="talent.compy.card3"
                            defaultMessage="TOOL"
                          />
                        </span>{" "}
                        <br />
                        <FormattedHTMLMessage
                          id="talent.compy.card3.sub"
                          defaultMessage="TEST"
                        />
                        <p>
                          <FormattedHTMLMessage
                            id="talent.compy.credit3"
                            defaultMessage="4 credits"
                          />
                        </p>
                      </button>
                    </li>
                    <li style={{ backgroundColor: "white", color: "black" }}>
                      <button
                        data-toggle="modal"
                        data-target="#sale"
                        className="btn"
                      >
                        <span style={{ color: "#18B6CE" }}>
                          <FormattedHTMLMessage
                            id="talent.compy.card4"
                            defaultMessage="TOOL"
                          />
                        </span>{" "}
                        <br />
                        <FormattedHTMLMessage
                          id="talent.compy.card4.sub"
                          defaultMessage="TEST"
                        />
                        <p>
                          <FormattedHTMLMessage
                            id="talent.compy.credit4"
                            defaultMessage="1 credit"
                          />
                        </p>
                      </button>
                    </li>
                    <li style={{ backgroundColor: "white", color: "black" }}>
                      <button
                        data-toggle="modal"
                        data-target="#target"
                        className="btn"
                      >
                        <span style={{ color: "#18B6CE" }}>
                          <FormattedHTMLMessage
                            id="talent.compy.card5"
                            defaultMessage="TOOL"
                          />
                        </span>{" "}
                        <br />
                        <FormattedHTMLMessage
                          id="talent.compy.card5.sub"
                          defaultMessage="TEST"
                        />
                        <p>
                          <FormattedHTMLMessage
                            id="talent.compy.credit5"
                            defaultMessage="1 credit"
                          />
                        </p>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="col-md-12 bottombox" id="unique">
          <section className="icon-boxed1 teaser-box mt-10" id="unique1">
            <div className="container">
              <div className="row">
                <p className="text-center w-100 ">
                  <FormattedHTMLMessage
                    id={ navigate === "skills" ? "talent.kit.heading" : "talent.compy.subs.head1" }
                    defaultMessage="All subscriptions provide access to all tools and can be recharged with credits at any time."
                  />
                </p>

                <div className="col-lg-4 col-md-4 responsive-mb">
                  <div className="icon-box text-center hero-bg box-shadow">
                    <div class="top-content">
                      <p>
                        {/* <Link to="/" className=""> */}
                        <FormattedHTMLMessage
                          id="talent.compy.subs.desc1"
                          defaultMessage="starter"
                        />
                        {/* </Link> */}
                      </p>

                      {/* <p>
                        <FormattedHTMLMessage
                          id="talent.compy.subs.desc2"
                          defaultMessage="12 months"
                        />
                      </p> */}

                      <div className="HalfBordr mt-4">
                        

                        <p className="mt-2">
                          <FormattedHTMLMessage
                            id={navigate === "skills" ? "talent.price.sub" : "talent.compy.subs.desc4"}
                            defaultMessage="12 months"
                          />
                        </p>
                      </div>
                      <p className="mt-2">
                        <FormattedHTMLMessage
                          id={navigate === "skills" ? "talent.kit.desc2" : "talent.compy.sub.desc5"}
                          defaultMessage="12 months"
                        />
                      </p>
                      {/* <p>
                    <FormattedHTMLMessage
                      id="talent.compy.sub.desc8"
                      defaultMessage="12 months"
                    />
                  </p>  */}
                    </div>
                    <div class="top-content width-add">
                      <p>
                        <Link
                          to="/register"
                          className="nav-link"
                          data-target=".navbar-collapse.show"
                          onClick={this.showalert2.bind(this)}
                        >
                          <button
                            class="btn btn-primary"
                            
                            style={{
                              background: "#18B6CE",
                              border: "none",
                              marginTop: "16%",
                              borderRradius: "5px",
                            }}
                          >
                            <FormattedHTMLMessage
                              id="taleny.compy.buy.1"
                              defaultMessage="Subscribe"
                            />
                          </button>
                        </Link>
                      </p>
                    </div>

                    {/* <div style={{marginTop:'50px'}}><Link to="/buy-test" className="nav-link"  data-target=".navbar-collapse.show"><button class="btn btn-primary" style={{background:"#18B6CE",border:"none",marginTop:"50px"}}><FormattedHTMLMessage id="coach.offer.subs.btn1" defaultMessage="Subscribe"/></button></Link></div> */}
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 responsive-mb">
                  <div className="icon-box text-center hero-bg box-shadow">
                    <div class="top-content width-add">
                      <p>
                        <FormattedHTMLMessage
                          id={ navigate === "skills" ? "Flex.head" : "talent.compy.subs.head2"}
                          defaultMessage="Classic"
                        />
                      </p>

                      <p>
                        <FormattedHTMLMessage
                          id={navigate === "skills" ? "flex.sub.head" : "talent.compy.subs.desc3"}
                          defaultMessage="€49.90"
                        />
                      </p>
                      <div className="HalfBordr mt-4">
                        <FormattedHTMLMessage
                          id={navigate === "skills" ? "flex.price" : "talent.compy.sub.desc7"}
                          defaultMessage="per month - annual payment"
                        />

                        <p className="mt-1">
                          <FormattedHTMLMessage
                            id={navigate === "skills" ? "flex.price.sub" : "talent.compy.sub.price"}
                            defaultMessage="per month - annual payment"
                          />
                        </p>
                      </div>
                      
                      <FormattedHTMLMessage
                          id={navigate === "skills" ? "flex.price.sub1" : "talent.compy.sub.desc9"}
                          defaultMessage="per month - annual payment"
                        />
                    </div>
                    <div class="top-content width-add">
                      {this.props.isSignedIn ? <p>
                        <Link
                          to="/buy-test"
                          className="nav-link"
                          onClick={this.showalert3.bind(this)}

                        >
                          <button
                            class="btn btn-primary"
                            style={{
                              background: "#18B6CE",
                              border: "none",
                              marginTop: "6%",
                            }}

                          >
                            <FormattedHTMLMessage
                              id="taleny.compy.buy.2"
                              defaultMessage="Subscribe"
                            />
                          </button>
                        </Link>
                      </p>
                        :
                        <p>
                          <Link
                            to="/register"
                            className="nav-link"
                            data-target=".navbar-collapse.show"
                            onClick={this.setBigGroup}
                          >
                            <button
                              class="btn btn-primary"
                              style={{
                                background: "#18B6CE",
                                border: "none",
                                marginTop: "6%",
                              }}
                              onClick={this.setEnterprise}

                            >
                              <FormattedHTMLMessage
                                id="taleny.compy.buy.2"
                                defaultMessage="Subscribe"
                              />
                            </button>
                          </Link>
                        </p>
                      }
                    </div>
                    {/* <div style={{marginTop:'50px'}}><Link to="/buy-test" className="nav-link"  data-target=".navbar-collapse.show"><button class="btn btn-primary" style={{background:"#18B6CE",border:"none"}}><FormattedHTMLMessage id="coach.offer.subs.btn2" defaultMessage="Subscribe"/></button></Link></div> */}
                    {/* <div  style={{ background: "#0a0a0aff", border: "none", padding: "8px", color:"#ffff", fontSize:"13px", }}>
                          <FormattedHTMLMessage id="black-friday-25" defaultMessage="Classic"/>
                      </div> */}
                  </div>

                </div>

                <div className="col-lg-4 col-md-4 responsive-mb">
                  <div className="icon-box text-center hero-bg box-shadow ">
                    <div class="top-content width-add">
                      <h3>
                        <FormattedHTMLMessage
                          id={navigate === "skills" ? "classic.flex.heading" : "talent.compy.fullass"}
                          defaultMessage="Classic"
                        />
                      </h3>

                      <p>
                        <FormattedHTMLMessage
                          id={navigate === "skills" ? "classic.flex.sub" : "talent.compy.fullass.sub"}
                          defaultMessage="€49.90"
                        />
                      </p>
                      <div className="HalfBordr mt-4">
                        <FormattedHTMLMessage
                          id={navigate === "skills" ? "classic.flex" : "talent.compy.fullass.sub2"}
                          defaultMessage="per month - annual payment"
                        />

                        <p className="mt-1">
                          <FormattedHTMLMessage
                            id={navigate === "skills" ? "classic.subprice" : "talent.compy.fullass.sub3"}
                            defaultMessage="per month - annual payment"
                          />
                        </p>
                      </div>
                      <div className="HalfBordr mt-1">
                        <FormattedHTMLMessage
                          id={navigate === "skills" ? "classic.sub.price.flex" : "talent.compy.fullass.sub4"}
                          defaultMessage="per month - annual payment"
                        />

                        <p className="mt-1">
                          <FormattedHTMLMessage
                            id={navigate === "skills" ? "classic.flex.rate" : "talent.compy.fullass.sub5"}
                            defaultMessage="per month - annual payment"
                          />
                        </p>
                      </div>
                    </div>
                    <div class="top-content width-add">
                      <p>
                        <Link
                          to={navigate === "enterprise" ? "/contact-us" : "/buy-subscription"}
                          className="nav-link"
                          data-target=".navbar-collapse.show"
                          onClick={this.setBigGroup.bind(this)}
                        >
                          <button
                            class="btn btn-primary"
                            style={{
                              background: "#18B6CE",
                              border: "none",
                              marginTop: "6%",
                            }}
                          >
                            <FormattedHTMLMessage
                              id={ navigate === "enterprise" ? "individual.calendly.button.business" : "classic.flex.btn" }
                              defaultMessage="Subscribe"
                            />
                          </button>
                        </Link>
                      </p>
                    </div>
                    {/* <div  style={{ background: "#0a0a0aff", border: "none", padding: "8px", color:"#ffff", fontSize:"13px", }}>
                          <FormattedHTMLMessage id="black-friday-35" defaultMessage="Classic"/>
                      </div> */}

                    {/* <div style={{marginTop:'50px'}}><Link to="/buy-test" className="nav-link"  data-target=".navbar-collapse.show"><button class="btn btn-primary" style={{background:"#18B6CE",border:"none"}}><FormattedHTMLMessage id="coach.offer.subs.btn2" defaultMessage="Subscribe"/></button></Link></div> */}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div className="modal fade pilotModal" id="happiness">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h4 className="modal-title text-center text-uppercase w-100 medium text-white font-20">
                  HAPPINESS Tool
                </h4>
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className=" mt-5">
                  <div className="about" id="services">
                    <div className=" text-justify">
                      <div
                        className=" animate animated slideInLeft"
                        data-animation="slideInLeft"
                      >
                        <h2 className="about-title text-left">
                          <FormattedHTMLMessage
                            id="hr.happiness.popup.title"
                            defaultMessage="HAPPINESS AT WORK TOOL"
                          />
                        </h2>
                      </div>
                      <div
                        className="add-width intro_layer mt-5 d-flex"
                        data-animation="fadeIn"
                      >
                        <div className="d-flex m-auto w-100">
                          <div className="d-inline-block w-50">
                            <button
                              onClick={this.openHappinessExamples.bind(this)}
                              className="btn btn-warning center-block example_button_radius"
                              style={{
                                backgroundColor: "#191970",
                                color: "white",
                              }}
                            >
                              <FormattedHTMLMessage
                                id="hr.happiness.btn.examples"
                                defaultMessage="SEE EXAMPLE OF RESULTS"
                              />
                            </button>
                          </div>
                          <div className="d-inline-block w-50">
                            <p>
                              <button
                                type="button"
                                className="btn  center-block example_button_radius"
                                onClick={this.openHappiness.bind(this)}
                                style={{
                                  backgroundColor: "#1ca9c9",
                                  color: "white",
                                }}
                              >
                                <FormattedHTMLMessage
                                  id="hr.happiness.btn.start"
                                  defaultMessage="START HAPPINESS TOOL"
                                />
                                <br />
                              </button>
                            </p>
                          </div>
                          <div className="d-inline-block w-50">
                            <p>
                              <button
                                class="btn btn-warning"
                                style={{
                                  backgroundColor: "#191970",
                                  color: "white",
                                }}
                                onClick={this.buyNowTest.bind(this)}
                              >
                                <FormattedMessage
                                  id="buynow"
                                  defaultMessage="Buy Now"
                                />
                              </button>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="hr.happiness.p.duration"
                          defaultMessage="<h3>Duration</h3><ul class='indi-ul'> <li>40 questions – 7 minutes.</li></ul>"
                        />
                        {/* <h3>Duration </h3>
                      <ul className="indi-ul">
                        <li>40 questions – 7 minutes. </li>
                      </ul> */}
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="hr.happiness.p.resultlist"
                          defaultMessage="<h3 class=''>Results </h3> <ul class='indi-ul'> <li> Global satisfaction of candidate compare to the average. </li><li> Detail of satisfaction on eight key factors of balance and development. </li><li>How candidate still improved happiness at work.</li></ul>"
                        />
                        {/* <h3 className="">Results </h3>
                      <ul className="indi-ul">
                        <li>
                          Global satisfaction of candidate compare to the
                          average.
                        </li>
                        <li>
                          Detail of satisfaction on eight key factors of balance
                          and development.
                        </li>
                        <li>How candidate still improved happiness at work.</li>
                      </ul> */}
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="hr.happiness.p.help"
                          defaultMessage="<h3 class=''>Help </h3> <ul class='indi-ul'> <li> Identify reasons of a possible malaise or weariness{' '}</li><li>Identify a specific coaching program.</li><li>Decide an internal or external mobility</li></ul>"
                        />
                        {/* <h3 className="">Help </h3>
                      <ul className="indi-ul">
                        <li>
                          Identify reasons of a possible malaise or weariness{" "}
                        </li>
                        <li>Identify a specific coaching program.</li>
                        <li>Decide an internal or external mobility</li>
                      </ul> */}
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="hr.happiness.p.research"
                          defaultMessage="<h3 class=''>Scientific-Researches </h3> <p class='modal-text'> MEASURE OF HAPPINESS AT WORK:</p><p class='pl-3'> Business life brings people together to ensure the best possible performance. Some of conditions must be met for everyone to flourish. Factors of balance and development at work : freedom of exchange, possibility of expressing one's wishes, personal action, career follow-up, possibility of working at one's own race, accomplishment of a work of freedom, identity, meaningless (L‘Identité au travail’ – R. Sainsaulieu – 1988 – Presses de la Fondation Nationale des Sciences Politiques).</p>"
                        />
                        {/* <h3 className="">Scientific-Researches </h3>
                      <p className="modal-text">
                        MEASURE OF HAPPINESS AT WORK:{" "}
                      </p>
                      <p className="pl-3">
                        Business life brings people together to ensure the best
                        possible performance. Some of conditions must be met for
                        everyone to flourish. Factors of balance and development
                        at work : freedom of exchange, possibility of expressing
                        one's wishes, personal action, career follow-up,
                        possibility of working at one's own race, accomplishment
                        of a work of freedom, identity, meaningless (L‘Identité
                        au travail’ – R. Sainsaulieu – 1988 – Presses de la
                        Fondation Nationale des Sciences Politiques).{" "}
                      </p> */}
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="hr.happiness.p.start.test"
                          defaultMessage="<h3 class=''>Start Your Test </h3> <div class='about-text'> <p> Before using ‘HAPPINESS Tool’ you can see an example of results exactly as you will send to your candidate. Results of test still totally confidential and we don’t use any named data coming from your candidate for other destination of the test (French Data Authority n°661001) </p></div>"
                        />
                        {/* <h3 className="">Start Your Test </h3>
                        <div className="about-text">
                        <p>
                          Before using ‘HAPPINESS Tool’ you can see an example
                          of results exactly as you will send to your candidate.
                          Results of test still totally confidential and we
                          don’t use any named data coming from your candidate
                          for other destination of the test (French Data
                          Authority n°661001)
                        </p>
                      </div>*/}
                        <div
                          className="add-width intro_layer mt-5 d-flex"
                          data-animation="fadeIn"
                        >
                          <div className="d-flex m-auto w-100">
                            <div className="d-inline-block w-50">
                              <button
                                onClick={this.openHappinessExamples.bind(this)}
                                className="btn btn-warning center-block example_button_radius"
                                style={{
                                  backgroundColor: "#191970",
                                  color: "white",
                                }}
                              >
                                <FormattedHTMLMessage
                                  id="hr.happiness.btn.examples"
                                  defaultMessage="SEE EXAMPLE OF RESULTS"
                                />
                              </button>
                            </div>
                            <div className="d-inline-block w-50">
                              <p>
                                <button
                                  type="button"
                                  className="btn  center-block example_button_radius"
                                  onClick={this.openHappiness.bind(this)}
                                  style={{
                                    backgroundColor: "#1ca9c9",
                                    color: "white",
                                  }}
                                >
                                  <FormattedHTMLMessage
                                    id="hr.happiness.btn.start"
                                    defaultMessage="START HAPPINESS TOOL"
                                  />
                                  <br />
                                </button>
                              </p>
                            </div>
                            <div className="d-inline-block w-50">
                              <p>
                                <button
                                  class="btn btn-warning"
                                  style={{
                                    backgroundColor: "#191970",
                                    color: "white",
                                  }}
                                  onClick={this.buyNowTest.bind(this)}
                                >
                                  <FormattedMessage
                                    id="buynow"
                                    defaultMessage="Buy Now"
                                  />
                                </button>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.happiness.price"
                          defaultMessage="<h3 class=''>Price </h3>"
                        />
                        {/* <ul className="indi-ul">
                        <li>
                          <FormattedHTMLMessage id="hr.happiness.price" defaultMessage="€ 15 1 credit"/>
                        </li>
                      </ul> */}
                        <div className="row">
                          <div className="col-md-12 col-sm-12 m-auto w100_991">
                            <div
                              className="card text-center mt-4"
                              style={{ border: "none" }}
                            >
                              {/* <div className="card-body"> */}
                              {/* <h4 className="card-title">
                                <del><FormattedHTMLMessage id="hr.happiness.single.price" defaultMessage="€ 15"/></del>
                              </h4> */}
                              {/* <p className="card-text"><i>HAPPINESS TOOL©</i></p> */}
                              {/* <p className="card-text"><FormattedHTMLMessage id="hr.happiness.price.credits" defaultMessage="(or 2 credits)"/></p> */}
                              {/* <button className="btn btn-warning" style={{backgroundColor:"#808080 "}}>
                                  <Link target="_blank" style={{color:"white"}}to="/contact-professional">
                                    <FormattedMessage id="ask.free.trial" defaultMessage="ASK FOR FREE TRIAL CREDIT"/>
                                  </Link>
                              </button> */}
                              {/* <button className="btn btn-warning" style={{backgroundColor:"#808080"}}>
                                  <Link target="_blank" style={{color:"white"}} to="/contact-professional">
                                    <FormattedMessage id="ask.free.tria2" defaultMessage="ASK FOR FREE CREDIT"/>
                                  </Link>
                                </button> */}
                              {/* <span><b style={{color:"#000", fontSize:"20px"}}><FormattedMessage id="ask.free.tria2" defaultMessage="ASK FOR FREE CREDIT"/></b></span>  */}

                              {/* </div> */}
                            </div>
                          </div>
                        </div>

                        <center>
                          <FormattedHTMLMessage
                            id="hr.license"
                            defaultMessage=""
                          />
                        </center>
                      </div>
                      <div>
                        <FormattedHTMLMessage
                          id="hr.pice.detail1"
                          defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade pilotModal" id="talent">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h4 className="modal-title text-center text-uppercase w-100 medium text-white font-20">
                  COACHING TOOL
                </h4>
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
              </div>

              <div className="modal-body">
                <div className="">
                  <div className="about" id="services">
                    <div className=" text-justify">
                      <div
                        className=" animate animated slideInLeft"
                        data-animation="slideInLeft"
                      >
                        <h2 className="about-title text-left">
                          <FormattedHTMLMessage
                            id="hr.coaching.popup.title"
                            defaultMessage="COACHING TOOL (TALENT + TARGET Tests)"
                          />
                        </h2>

                        <div
                          className="add-width intro_layer mt-5 d-flex"
                          data-animation="fadeIn"
                        >
                          <div className="d-flex m-auto w-100">
                            <div className="d-inline-block w-50">
                              <button
                                type="button"
                                className="btn btn-warning center-block example_button_radius"
                                onClick={this.openCoachingCareerExamples.bind(
                                  this
                                )}
                                style={{
                                  backgroundColor: "#191970",
                                  color: "white",
                                }}
                              >
                                <FormattedHTMLMessage
                                  id="hr.coaching.btn.examples"
                                  defaultMessage="SEE EXAMPLE OF RESULTS"
                                />
                              </button>
                            </div>
                            <div className="d-inline-block w-50">
                              <p>
                                <button
                                  type="button"
                                  className="btn  center-block example_button_radius"
                                  onClick={this.openCoachingCareer.bind(this)}
                                  style={{
                                    backgroundColor: "#1ca9c9",
                                    color: "white",
                                  }}
                                >
                                  <FormattedHTMLMessage
                                    id="hr.coaching.btn.start"
                                    defaultMessage="START COACHING TOOL"
                                  />
                                </button>
                              </p>
                            </div>
                            <div className="d-inline-block w-50">
                              <p>
                                <button
                                  class="btn btn-warning"
                                  style={{
                                    backgroundColor: "#191970",
                                    color: "white",
                                  }}
                                  onClick={this.buyNowTest.bind(this)}
                                >
                                  <FormattedMessage
                                    id="buynow"
                                    defaultMessage="Buy Now"
                                  />
                                </button>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="indi-list">
                          <FormattedHTMLMessage
                            id="hr.coaching.p.duration"
                            defaultMessage="<h3>Duration</h3><ul className='indi-ul'> <li>40 questions – 7 minutes.</li></ul>"
                          />
                          {/* <h3>Duration</h3>
                        <ul className="indi-ul">
                          <li>
                            40 questions – 10 minutes (MyTalent Test + MyTarget
                            Test){" "}
                          </li>
                        </ul> */}
                        </div>
                        <div className="indi-list">
                          <FormattedHTMLMessage
                            id="hr.coaching.p.resultlist"
                            defaultMessage="<h3 class=''>Résults</h3> <ul className='indi-ul'> <li> Highlight personality and talents of candidate </li><li> Communication skills of candidate and weak point to coach </li><li> Best place to work for candidate according his/her personality</li></ul>"
                          />
                          {/* <h3 className="">Résults</h3>
                        <ul className="indi-ul">
                          <li>
                            Highlight personality and talents of candidate
                          </li>
                          <li>
                            Communication skills of candidate and weak point to
                            coach
                          </li>
                          <li>
                            Best place to work for candidate according his/her
                            personality{" "}
                          </li>
                        </ul> */}
                        </div>
                        <div className="indi-list">
                          <FormattedHTMLMessage
                            id="hr.coaching.p.help"
                            defaultMessage="<h3 class=''>Help</h3> <ul className='indi-ul'> <li>Make a clear and deep HR Check-up.</li><li>Focus on weak point to coach </li><li>Find the way of excellence of the candidate.</li></ul>"
                          />
                          {/* <h3 className="">Help</h3>
                        <ul className="indi-ul">
                          <li>Make a clear and deep HR Check-up.</li>
                          <li>Focus on weak point to coach </li>
                          <li>Find the way of excellence of the candidate.</li>
                        </ul> */}
                        </div>
                        <div className="indi-list">
                          <FormattedHTMLMessage
                            id="hr.coaching.p.research"
                            defaultMessage="<h3 class=''>Scientific-Researches </h3> <p className='modal-text'>MEASURE OF PERSONALITY:</p><p className='pl-3'> The work of C. J Jung showed that each person approaches the world differently (The man discovering his soul C.G. Jung - 1963). Some of them by the concrete and the operational, the others by the abstract and the functional. C G Jung draws typologies of functioning to better understand and accept the differences between individuals. My <b className='title_italic'>MyTALENT TEST©</b> highlights four typical professions related to this typology against which candidate will be able to evaluate (The manager/organizer; The inventor/engineer The doer; The communicator). </p><p className='modal-text'>MEASURE OF MOTIVATIONS:</p><p className='pl-3'> The work of E. Schein showed that each person has career anchors or dominant motivational traits that last a lifetime and that can be relied on by the person to build a career (Career Anchors - E. Schein - 1996 - Last edition 2013). MyTALENT Test allows the candidate to prioritize and reveal their motivational preferences (Leadership, service to others, challenge, safety, balance of life, entrepreneurial spirit, autonomy, expertise). </p><p className='modal-text'> MEASURE OF COMMUNICATION STYLE: </p><p className='pl-3'> The work of Isabelle Filliozat (L’intelligence du coeur – I. Filliozat – 1995. Last edition 2013 - Paris Ed. JC Lattès) highlights that emotions leave a strong mark on the personality (fear, anger, sadness, joy). . Often a taboo topic, feelings are not always well understood. The ability to manage one's feelings and those of others increases communication and persuasion skills. </p><p className='pl-3'> Seven skills are used to assess the Emotional Quotient (E.Q.) has been highlight by. MyTALENT test allows the candidate to reveal his/her level of communication and what could be still improve (awareness of feelings, ability to share emotion, ability to live in a group, ability to convey emotion with a group, ability to listen to others, confidence to live with emotion, freedom to follow emotion). </p><p className='modal-text'>MEASURE OF WORK CONTEXTS :</p><p className='pl-3'> The work of I. Francfort, F. Osty, M. Uhalde (Les mondes sociaux de l’entreprise – Paris 1995 – Ed. Desclée de Brouwer) showed that each company has a body of rules that makes it belong to different social worlds Each individual also has their own culture. MyTARGET Test allows the candidate to check which socio-professional world he feels closest to and where he can best develop (regulatory world, community, professional public service, professional, mobility, entrepreneurial). </p><p className='modal-text'>MEASURE OF WORK CULTURE :</p><p className='pl-3'> The work of C. Hampden-Turner (La culture d’entreprise : des cercles vicieux aux cercles vertueux – Paris 1992 – Ed. Du Seuil) showed that each company has a mix of culture composed by history, actions, relationships, thinking, know-how and people. MyTARGET Test allows the candidate to check what is most important for him/her and suit best with companies. </p><p className='modal-text'> MEASURE OF WORK MANAGEMENT : </p><p className='pl-3'> The work of C. Handy (L’Olympe des Managers – 1992 – Paris - Ed. Du Seuil) showed that management approach still very different in Institution, Corporation, Small Business or independent. Each people has his/her own references and habits. MyTARGET Test allows the candidate to sort witch management approach suit best to him or her. </p><p className='modal-text'> MEASURE OF WORK ATMOSPHERE : </p><p className='pl-3'> The work of P. Pitcher (Artistes, Artisans et Technocrates –Paris - 1996– Ed. Village Mondial) showed that you are more productive if you find the right atmosphere according to your personality. MyTARGET Test allows the candidate to sort with witch people and atmosphere suit best to him or her.</p>"
                          />
                          {/* <h3 className="">Scientific-Researches </h3>
                        <p className="modal-text">MEASURE OF PERSONALITY:</p>
                        <p className="pl-3">
                          The work of C. J Jung showed that each person
                          approaches the world differently (The man discovering
                          his soul C.G. Jung - 1963). Some of them by the
                          concrete and the operational, the others by the
                          abstract and the functional. C G Jung draws typologies
                          of functioning to better understand and accept the
                          differences between individuals. My TALENT Test
                          highlights four typical professions related to this
                          typology against which candidate will be able to
                          evaluate (The manager/organizer; The inventor/engineer
                          The doer; The communicator).
                        </p>
                        <p className="modal-text">MEASURE OF MOTIVATIONS:</p>
                        <p className="pl-3">
                          The work of E. Schein showed that each person has
                          career anchors or dominant motivational traits that
                          last a lifetime and that can be relied on by the
                          person to build a career (Career Anchors - E. Schein -
                          1996 - Last edition 2013). MyTALENT Test allows the
                          candidate to prioritize and reveal their motivational
                          preferences (Leadership, service to others, challenge,
                          safety, balance of life, entrepreneurial spirit,
                          autonomy, expertise).
                        </p>
                        <p className="modal-text">
                          MEASURE OF COMMUNICATION STYLE:
                        </p>
                        <p className="pl-3">
                          The work of Isabelle Filliozat (L’intelligence du
                          coeur – I. Filliozat – 1995. Last edition 2013 - Paris
                          Ed. JC Lattès) highlights that emotions leave a strong
                          mark on the personality (fear, anger, sadness, joy). .
                          Often a taboo topic, feelings are not always well
                          understood. The ability to manage one's feelings and
                          those of others increases communication and persuasion
                          skills.
                        </p>
                        <p className="pl-3">
                          Seven skills are used to assess the Emotional Quotient
                          (E.Q.) has been highlight by. MyTALENT test allows the
                          candidate to reveal his/her level of communication and
                          what could be still improve (awareness of feelings,
                          ability to share emotion, ability to live in a group,
                          ability to convey emotion with a group, ability to
                          listen to others, confidence to live with emotion,
                          freedom to follow emotion).
                        </p>
                        <p className="modal-text">MEASURE OF WORK CONTEXTS :</p>
                        <p className="pl-3">
                          The work of I. Francfort, F. Osty, M. Uhalde (Les
                          mondes sociaux de l’entreprise – Paris 1995 – Ed.
                          Desclée de Brouwer) showed that each company has a
                          body of rules that makes it belong to different social
                          worlds Each individual also has their own culture.
                          MyTARGET Test allows the candidate to check which
                          socio-professional world he feels closest to and where
                          he can best develop (regulatory world, community,
                          professional public service, professional, mobility,
                          entrepreneurial).
                        </p>
                        <p className="modal-text">MEASURE OF WORK CULTURE :</p>
                        <p className="pl-3">
                          The work of C. Hampden-Turner (La culture d’entreprise
                          : des cercles vicieux aux cercles vertueux – Paris
                          1992 – Ed. Du Seuil) showed that each company has a
                          mix of culture composed by history, actions,
                          relationships, thinking, know-how and people. MyTARGET
                          Test allows the candidate to check what is most
                          important for him/her and suit best with companies.
                        </p>
                        <p className="modal-text">
                          MEASURE OF WORK MANAGEMENT :
                        </p>
                        <p className="pl-3">
                          The work of C. Handy (L’Olympe des Managers – 1992 –
                          Paris - Ed. Du Seuil) showed that management approach
                          still very different in Institution, Corporation,
                          Small Business or independent. Each people has his/her
                          own references and habits. MyTARGET Test allows the
                          candidate to sort witch management approach suit best
                          to him or her.
                        </p>
                        <p className="modal-text">
                          MEASURE OF WORK ATMOSPHERE :
                        </p>
                        <p className="pl-3">
                          The work of P. Pitcher (Artistes, Artisans et
                          Technocrates –Paris - 1996– Ed. Village Mondial)
                          showed that you are more productive if you find the
                          right atmosphere according to your personality.
                          MyTARGET Test allows the candidate to sort with witch
                          people and atmosphere suit best to him or her.{" "}
                        </p> */}
                        </div>
                        <div className="indi-list">
                          <div className="about-text">
                            <FormattedHTMLMessage
                              id="hr.coaching.p.start.test"
                              defaultMessage="<h3 class=''>Start Your Test </h3> <div className='about-text'> To assess your client, you have two assessment tools : <ol> <li> <b>The <b className='title_italic'>MyTALENT TEST©</b></b> to highlight motivations, personality, strengths, talents, abilities to communicate. </li><li><b>The TARGET Test</b> to highlight work culture, work contexts, work atmosphere, management approaches that suit best to the client.</li></ol> <p> Before using ‘CAREER Assessment tools’ you can see an example of results exactly as you will give to your candidate. Results of test still totally confidential and we don’t use any named data coming from your candidate for other destination of the test (French Data Authority n°661001)</p></div>"
                            />
                            {/* <h3 className="">Start Your Test </h3>
                        <div className="about-text">
                          To assess your client, you have two assessment tools :
                          <ol>
                            <li>
                              <b>The <b className='title_italic'>MyTALENT TEST©</b></b> to highlight motivations,
                              personality, strengths, talents, abilities to
                              communicate.
                            </li>
                            <li>
                              {" "}
                              <b>The TARGET Test</b> to highlight work culture,
                              work contexts, work atmosphere, management
                              approaches that suit best to the client.{" "}
                            </li>
                          </ol>
                          <p>
                            Before using ‘CAREER Assessment tools’ you
                            can see an example of results exactly as you will
                            give to your candidate. Results of test still
                            totally confidential and we don’t use any named data
                            coming from your candidate for other destination of
                            the test (French Data Authority n°661001){" "}
                          </p>
                        </div> */}
                            <div
                              className="add-width intro_layer mt-5 d-flex"
                              data-animation="fadeIn"
                            >
                              <div className="d-flex m-auto w-100">
                                <div className="d-inline-block w-50">
                                  <button
                                    type="button"
                                    className="btn btn-warning center-block example_button_radius"
                                    onClick={this.openCoachingCareerExamples.bind(
                                      this
                                    )}
                                    style={{
                                      backgroundColor: "#191970",
                                      color: "white",
                                    }}
                                  >
                                    <FormattedHTMLMessage
                                      id="hr.coaching.btn.examples"
                                      defaultMessage="SEE EXAMPLE OF RESULTS"
                                    />
                                  </button>
                                </div>
                                <div className="d-inline-block w-50">
                                  <p>
                                    <button
                                      type="button"
                                      className="btn  center-block example_button_radius"
                                      onClick={this.openCoachingCareer.bind(
                                        this
                                      )}
                                      style={{
                                        backgroundColor: "#1ca9c9",
                                        color: "white",
                                      }}
                                    >
                                      <FormattedHTMLMessage
                                        id="hr.coaching.btn.start"
                                        defaultMessage="START COACHING TOOL"
                                      />
                                    </button>
                                  </p>
                                </div>
                                <div className="d-inline-block w-50">
                                  <p>
                                    <button
                                      class="btn btn-warning"
                                      style={{
                                        backgroundColor: "#191970",
                                        color: "white",
                                      }}
                                      onClick={this.buyNowTest.bind(this)}
                                    >
                                      <FormattedMessage
                                        id="buynow"
                                        defaultMessage="Buy Now"
                                      />
                                    </button>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="indi-list">
                          <FormattedHTMLMessage
                            id="ind.happiness.price"
                            defaultMessage="<h3 class=''>Price </h3>"
                          />
                          {/* <ul className="indi-ul">
                          <li><FormattedHTMLMessage id="hr.coaching.price" defaultMessage="€ 30 COACHING TOOL© (ou 2 crédits)"/></li>
                        </ul> */}
                          <div className="row">
                            <div className="col-md-12 col-sm-12 m-auto w100_991">
                              <div
                                className="card text-center mt-4"
                                style={{ border: "none" }}
                              >
                                {/* <div className="card-body">
                                <h4 className="card-title"><del><FormattedMessage id="hr.coaching.single.price" defaultMessage="€ 30"/></del></h4>
                                <p className="card-text"><i>COACHING TOOL©</i></p> */}
                                {/* <p className="card-text"><FormattedHTMLMessage id="hr.coaching.price.credits" defaultMessage="(or 2 credits)"/></p> */}
                                {/* <button className="btn btn-warning" style={{backgroundColor:"#808080"}}>
                                  <Link target="_blank" style={{color:"white"}} to="/contact-professional">
                                    <FormattedMessage id="ask.free.tria2" defaultMessage="ASK FOR FREE CREDIT"/>
                                  </Link>
                                </button> */}
                                {/* <span><b style={{color:"#000", fontSize:"20px"}}><FormattedMessage id="ask.free.tria2" defaultMessage="ASK FOR FREE CREDIT"/></b></span>  */}

                                {/* </div> */}
                              </div>
                            </div>
                          </div>

                          <center>
                            <FormattedHTMLMessage
                              id="hr.license"
                              defaultMessage=""
                            />
                          </center>
                        </div>
                        <div>
                          <FormattedHTMLMessage
                            id="hr.pice.detail1"
                            defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade pilotModal" id="target">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h4 className="modal-title text-center text-uppercase w-100 medium text-white font-20">
                  BUSINESS CREATION Tool
                </h4>
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
              </div>

              <div className="modal-body">
                <div className="">
                  <div className="about" id="services">
                    <div className=" text-justify">
                      <div
                        className=" animate animated slideInLeft"
                        data-animation="slideInLeft"
                      >
                        <h2 className="about-title text-left">
                          <FormattedHTMLMessage
                            id="hr.buss.creation.popup.title"
                            defaultMessage="BUSINESS CREATION TOOL"
                          />
                        </h2>
                      </div>
                      <div
                        className="add-width intro_layer mt-5 d-flex"
                        data-animation="fadeIn"
                      >
                        <div className="d-flex m-auto w-100">
                          <div className="d-inline-block w-50">
                            <button
                              type="button"
                              className="btn btn-warning center-block example_button_radius"
                              onClick={this.openBusinessCreationExamples.bind(
                                this
                              )}
                              style={{
                                backgroundColor: "#191970",
                                color: "white",
                              }}
                            >
                              <FormattedHTMLMessage
                                id="hr.buss.creation.btn.examples"
                                defaultMessage="SEE EXAMPLE OF RESULTS"
                              />
                            </button>
                          </div>
                          <div className="d-inline-block w-50">
                            <p>
                              <button
                                type="button"
                                className="btn  center-block example_button_radius"
                                onClick={this.openBusinessCreation.bind(this)}
                                style={{
                                  backgroundColor: "#1ca9c9",
                                  color: "white",
                                }}
                              >
                                <FormattedHTMLMessage
                                  id="hr.buss.creation.btn.start"
                                  defaultMessage="START BUSINESS CREATION TOOL"
                                />
                              </button>
                            </p>
                          </div>
                          <div className="d-inline-block w-50">
                            <p>
                              <button
                                class="btn btn-warning"
                                style={{
                                  backgroundColor: "#191970",
                                  color: "white",
                                }}
                                onClick={this.buyNowTest.bind(this)}
                              >
                                <FormattedMessage
                                  id="buynow"
                                  defaultMessage="Buy Now"
                                />
                              </button>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="hr.buss.creation.p.duration"
                          defaultMessage="<h3>Duration</h3><ul className='indi-ul'> <li>40 questions – 7 minutes.</li></ul>"
                        />
                        {/* <h3>Duration </h3>
                      <ul className="indi-ul">
                        <li>40 questions – 7 minutes. </li>
                      </ul> */}
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="hr.buss.creation.p.resultlist"
                          defaultMessage="<h3 className=''>Results </h3> <ul className='indi-ul'> <li> Global potential of business creation of a candidate </li><li> Details of potential on eight business creation key factors </li><li>How candidate still improved his/her success.</li></ul>"
                        />
                        {/* <h3 className="">Results </h3>
                      <ul className="indi-ul">
                        <li>
                          Global potential of business creation of a candidate
                        </li>
                        <li>
                          Details of potential on eight business creation key
                          factors
                        </li>
                        <li>How candidate still improved his/her success.</li>
                      </ul> */}
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="hr.buss.creation.p.help"
                          defaultMessage="<h3 className=''>Help </h3> <ul className='indi-ul'> <li>Practical online assessment before interview.</li><li> Identify if candidate is ready or not to create. </li><li> Identify if candidate has skills to create his/her own business. </li></ul>"
                        />
                        {/* <h3 className="">Help </h3>
                      <ul className="indi-ul">
                        <li>Practical online assessment before interview.</li>
                        <li>
                          Identify if candidate is ready or not to create.
                        </li>
                        <li>
                          Identify if candidate has skills to create his/her own
                          business.
                        </li>
                      </ul> */}
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="hr.buss.creation.p.research"
                          defaultMessage="<h3 className=''>Scientific-Researches </h3> <p className='modal-text'> MEASURE OF BUSINESS CREATION POTENTIAL : </p><p className='pl-3'> The work of R. Papin (La creation d’entreprise – Paris 2015 – Ed. Dunod) highlighted best practices and technical approach to create his/her own business confirmed by H.E.C High Business School (Hautes Etudes Commerciales). PILOT RH® allows the candidate to assess himself (herself) on eight keys factors of success to create his/her own business (Initiative / creativity, Ambition / work load, Ability to manage people, Ability to sell, Organisational skills, Business knowledge, Ability to run a business, Personal situation). </p>"
                        />
                        {/* <h3 className="">Scientific-Researches </h3>
                      <p className="modal-text">
                        MEASURE OF BUSINESS CREATION POTENTIAL :
                      </p>
                      <p className="pl-3">
                        The work of R. Papin (La creation d’entreprise – Paris
                        2015 – Ed. Dunod) highlighted best practices and
                        technical approach to create his/her own business
                        confirmed by H.E.C High Business School (Hautes Etudes
                        Commerciales). PILOT RH® allows the candidate to assess
                        himself (herself) on eight keys factors of success to
                        create his/her own business (Initiative / creativity,
                        Ambition / work load, Ability to manage people, Ability
                        to sell, Organisational skills, Business knowledge,
                        Ability to run a business, Personal situation).
                      </p> */}
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="hr.buss.creation.p.start.test"
                          defaultMessage="<h3 class=''>Start Your Test </h3> <div className='about-text'> <p> Before using b className='title_italic'>BUSINESS CREATION Tools©</b> you can see an example of results similar to those you will get after taking the test. The results of your test are totally confidential and we will not disclose any data you provide to any other party or organisation (French Data Authority n°661001).</p></div>"
                        />
                        {/* <h3 className="">Start Your Test </h3>
                        <div className="about-text">
                        <p>
                          Before using ‘BUSINESS CREATION Tools’ you can see an
                          example of results exactly as you will send to your
                          candidate. Results of test still totally confidential
                          and we don’t use any named data coming from your
                          candidate for other destination of the test (French
                          Data Authority n°661001){" "}
                        </p>
                        </div>*/}
                        <div
                          className="add-width intro_layer mt-5 d-flex"
                          data-animation="fadeIn"
                        >
                          <div className="d-flex m-auto w-100">
                            <div className="d-inline-block w-50">
                              <button
                                type="button"
                                className="btn btn-warning center-block example_button_radius"
                                onClick={this.openBusinessCreationExamples.bind(
                                  this
                                )}
                                style={{
                                  backgroundColor: "#191970",
                                  color: "white",
                                }}
                              >
                                <FormattedHTMLMessage
                                  id="hr.buss.creation.btn.examples"
                                  defaultMessage="SEE EXAMPLE OF RESULTS"
                                />
                              </button>
                            </div>
                            <div className="d-inline-block w-50">
                              <p>
                                <button
                                  type="button"
                                  className="btn  center-block example_button_radius"
                                  onClick={this.openBusinessCreation.bind(this)}
                                  style={{
                                    backgroundColor: "#1ca9c9",
                                    color: "white",
                                  }}
                                >
                                  <FormattedHTMLMessage
                                    id="hr.buss.creation.btn.start"
                                    defaultMessage="START BUSINESS CREATION TOOL"
                                  />
                                </button>
                              </p>
                            </div>
                            <div className="d-inline-block w-50">
                              <p>
                                <button
                                  class="btn btn-warning"
                                  style={{
                                    backgroundColor: "#191970",
                                    color: "white",
                                  }}
                                  onClick={this.buyNowTest.bind(this)}
                                >
                                  <FormattedMessage
                                    id="buynow"
                                    defaultMessage="Buy Now"
                                  />
                                </button>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="indi-list">
                        <h3 className="">
                          <FormattedMessage
                            id="price"
                            defaultMessage="Price "
                          />
                        </h3>
                        {/* <ul className="indi-ul">
                        <li><FormattedMessage id="hr.buss.creation.price" defaultMessage="€ 15 (1 credit)"/></li>
                      </ul> */}
                        <div className="row">
                          <div className="col-md-12 col-sm-12 m-auto w100_991">
                            <div
                              className="card text-center mt-4"
                              style={{ border: "none" }}
                            >
                              {/* <div className="card-body"> */}
                              {/* <h4 className="card-title"><del><FormattedMessage id="hr.buss.creation.single.price" defaultMessage="€ 15"/> </del></h4> */}
                              {/* <p className="card-text"><i>BUSINESS CREATION TOOL©</i> </p> */}
                              {/* <p className="card-text"><FormattedMessage id="hr.buss.creation.price.credits" defaultMessage="(1 credit)"/> </p>  */}
                              {/* <button className="btn btn-warning">
                              <FormattedMessage id="hr.buss.creation.week.trial" defaultMessage="FREE ON WEEK TRIAL"/>
                              </button>
                            </div> */}
                              {/* <button className="btn btn-warning" style={{backgroundColor:"#808080 "}}>
                                  <Link target="_blank" style={{color:"white"}} to="/contact-professional">
                                    <FormattedMessage id="ask.free.tria2" defaultMessage="ASK FOR FREE CREDIT"/>
                                  </Link>
                                </button> */}
                              {/* <span><b style={{color:"#000", fontSize:"20px"}}><FormattedMessage id="ask.free.tria2" defaultMessage="ASK FOR FREE CREDIT"/></b></span>  */}
                            </div>
                          </div>
                        </div>

                        <center>
                          <FormattedHTMLMessage
                            id="hr.license"
                            defaultMessage=""
                          />
                        </center>
                      </div>
                    </div>
                    <FormattedHTMLMessage
                      id="hr.pice.detail1"
                      defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade pilotModal" id="sale">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h4 className="modal-title text-center text-uppercase w-100 medium text-white font-20">
                  SALES FORCE Tool
                </h4>
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
              </div>

              <div className="modal-body">
                <div className="">
                  <div className="about" id="services">
                    <div className=" text-justify">
                      <div
                        className=" animate animated slideInLeft"
                        data-animation="slideInLeft"
                      >
                        <h2 className="about-title text-left">
                          <FormattedHTMLMessage
                            id="hr.sale.force.popup.title"
                            defaultMessage="SALES FORCE Tool"
                          />
                        </h2>
                      </div>
                      <div
                        className="add-width intro_layer mt-5 d-flex"
                        data-animation="fadeIn"
                      >
                        <div className="d-flex m-auto w-100">
                          <div className="d-inline-block w-50">
                            <button
                              type="button"
                              className="btn btn-warning center-block example_button_radius"
                              onClick={this.openSaleExamples.bind(this)}
                              style={{
                                backgroundColor: "#191970",
                                color: "white",
                              }}
                            >
                              <FormattedHTMLMessage
                                id="hr.buss.creation.btn.examples"
                                defaultMessage="SEE EXAMPLE OF RESULTS"
                              />
                            </button>
                          </div>
                          <div className="d-inline-block w-50">
                            <p>
                              <button
                                type="button"
                                className="btn  center-block example_button_radius"
                                onClick={this.openSale.bind(this)}
                                style={{
                                  backgroundColor: "#1ca9c9",
                                  color: "white",
                                }}
                              >
                                <FormattedHTMLMessage
                                  id="hr.sale.force.btn.start"
                                  defaultMessage="START BUSINESS CREATION TOOL"
                                />
                              </button>
                            </p>
                          </div>
                          <div className="d-inline-block w-50">
                            <p>
                              <button
                                class="btn btn-warning"
                                style={{
                                  backgroundColor: "#191970",
                                  color: "white",
                                }}
                                onClick={this.buyNowTest.bind(this)}
                              >
                                <FormattedMessage
                                  id="buynow"
                                  defaultMessage="Buy Now"
                                />
                              </button>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="hr.sale.force.p.duration"
                          defaultMessage="<h3>Duration</h3><ul className='indi-ul'> <li>40 questions – 7 minutes.</li></ul>"
                        />
                        {/* <h3>Duration</h3>
                      <ul className="indi-ul">
                        <li>40 questions – 7minutes.</li>
                      </ul> */}
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="hr.sale.force.p.help"
                          defaultMessage="<h3 className=''>Help </h3> <ul className='indi-ul'> <li>Practical online assessment before interview.</li><li> Identify if candidate is ready or not to create. </li><li> Identify if candidate has skills to create his/her own business. </li></ul>"
                        />
                        {/* <h3 className="">Help</h3>
                      <ul className="indi-ul">
                        <li>Practical online assessment before interview.</li>
                        <li>Identify if candidate is good to sale</li>
                        <li>Identify coaching program to improve sale </li>
                      </ul> */}
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="hr.sale.force.p.resultlist"
                          defaultMessage="<h3 className=''>Results </h3> <ul className='indi-ul'> <li> Global potential of business creation of a candidate </li><li> Details of potential on eight business creation key factors </li><li>How candidate still improved his/her success.</li></ul>"
                        />
                        {/* <h3 className="">Results</h3>
                      <ul className="indi-ul">
                        <li>Global potential of sale of a candidate</li>
                        <li>
                          Detail of potential of sale on eight key factors of
                          success.
                        </li>
                        <li>How candidate still improved sale.</li>
                      </ul> */}
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="hr.sale.force.p.start.test"
                          defaultMessage="<h3 className=''>Start Your Test </h3> <div className='about-text'> <p> Before using ‘BUSINESS CREATION Tools’ you can see an example of results exactly as you will send to your candidate. Results of test still totally confidential and we don’t use any named data coming from your candidate for other destination of the test (French Data Authority n°661001)</p></div>"
                        />
                        {/* <h3 className="">Start Your Test </h3>
                        <div className="about-text">
                        <p>
                          Before using ‘SALE FORCE Assessment tools’ you can see
                          an example of results exactly as you will send to your
                          candidate. Results of test still totally confidential
                          and we don’t use any named data coming from your
                          candidate for other destination of the test (French
                          Data Authority n°661001)
                        </p>
                        </div>*/}
                        <div
                          className="add-width intro_layer mt-5 d-flex"
                          data-animation="fadeIn"
                        >
                          <div className="d-flex m-auto w-100">
                            <div className="d-inline-block w-50">
                              <button
                                type="button"
                                className="btn btn-warning center-block example_button_radius"
                                onClick={this.openSaleExamples.bind(this)}
                                style={{
                                  backgroundColor: "#191970",
                                  color: "white",
                                }}
                              >
                                <FormattedHTMLMessage
                                  id="hr.buss.creation.btn.examples"
                                  defaultMessage="SEE EXAMPLE OF RESULTS"
                                />
                              </button>
                            </div>
                            <div className="d-inline-block w-50">
                              <p>
                                <button
                                  type="button"
                                  className="btn  center-block example_button_radius"
                                  onClick={this.openSale.bind(this)}
                                  style={{
                                    backgroundColor: "#1ca9c9",
                                    color: "white",
                                  }}
                                >
                                  <FormattedHTMLMessage
                                    id="hr.sale.force.btn.start"
                                    defaultMessage="START BUSINESS CREATION TOOL"
                                  />
                                </button>
                              </p>
                            </div>
                            <div className="d-inline-block w-50">
                              <p>
                                <button
                                  class="btn btn-warning"
                                  style={{
                                    backgroundColor: "#191970",
                                    color: "white",
                                  }}
                                  onClick={this.buyNowTest.bind(this)}
                                >
                                  <FormattedMessage
                                    id="buynow"
                                    defaultMessage="Buy Now"
                                  />
                                </button>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="indi-list">
                        <h3 className="">
                          <FormattedMessage
                            id="price"
                            defaultMessage="Price "
                          />
                        </h3>
                        {/* <ul className="indi-ul">
                        <li><FormattedMessage id="hr.sale.force.price" defaultMessage="€ 15"/></li>
                      </ul> */}
                        <div className="row">
                          <div className="col-md-12 col-sm-12 m-auto w100_991">
                            <div
                              className="card text-center mt-4"
                              style={{ border: "none" }}
                            >
                              {/* <div className="card-body">
                              <h4 className="card-title"> <del><FormattedMessage id="hr.sale.force.single.price" defaultMessage="€ 15"/></del></h4>
                              <p className="card-text">
                                <FormattedHTMLMessage id="hr.sale.force.price.title" defaultMessage="SALES FORCE Tool"/>
                              </p> */}
                              {/* <p className="card-text"><FormattedHTMLMessage id="hr.sale.force.price.credits" defaultMessage="(or 1 crédit)"/> </p> */}
                              {/* <Link  className="btn btn-light btn-ligh-blue" to="/buy-test">
                                  <FormattedMessage id="buynow" defaultMessage="Buy Now"/>
                              </Link> */}
                              {/* <button className="btn btn-warning" style={{backgroundColor:"#808080 "}}>
                                  <Link target="_blank" style={{color:"white"}} to="/contact-professional">
                                    <FormattedMessage id="ask.free.tria2" defaultMessage="ASK FOR FREE CREDIT"/>
                                  </Link>
                                </button> */}
                              {/* <span><b style={{color:"#000", fontSize:"20px"}}><FormattedMessage id="ask.free.tria2" defaultMessage="ASK FOR FREE CREDIT"/></b></span>  */}

                              {/* </div> */}
                            </div>
                          </div>
                        </div>

                        <center>
                          <FormattedHTMLMessage
                            id="hr.license"
                            defaultMessage=""
                          />
                        </center>
                      </div>
                    </div>
                    <FormattedHTMLMessage
                      id="hr.pice.detail1"
                      defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade pilotModal" id="enterprise">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h4 className="modal-title text-center text-uppercase w-100 medium text-white font-20">
                  ENTERPRISE TOOL
                </h4>
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
              </div>

              <div className="modal-body">
                <div className="col-md-12">
                  <div className="about" id="services">
                    <div className="container text-justify">
                      <div
                        className=" animate animated slideInLeft"
                        data-animation="slideInLeft"
                      >
                        <h2 className="about-title text-left">
                          ENTERPRISE TOOL
                        </h2>
                      </div>
                      <div
                        className="add-width intro_layer mt-5 d-flex"
                        data-animation="fadeIn"
                      >
                        <div className="d-inline-block w-50">
                          <p>
                            <button
                              type="button"
                              className="btn bg-secondary center-block"
                              onClick={this.openRecruitmentExamples.bind(this)}
                              style={{
                                backgroundColor: "#191970",
                                color: "white",
                              }}
                            >
                              See example of results
                            </button>
                          </p>
                        </div>
                        <div className="d-inline-block w-50">
                          <button
                            type="button"
                            className="btn  center-block example_button_radius"
                            onClick={this.openRecruitment.bind(this)}
                            style={{
                              backgroundColor: "#1ca9c9",
                              color: "white",
                            }}
                          >
                            START RECRUITMENT Test
                          </button>
                        </div>
                        <div className="d-inline-block w-50">
                          <p>
                            <button
                              class="btn btn-warning"
                              style={{
                                backgroundColor: "#191970",
                                color: "white",
                              }}
                              onClick={this.buyNowTest.bind(this)}
                            >
                              <FormattedMessage
                                id="buynow"
                                defaultMessage="Buy Now"
                              />
                            </button>
                          </p>
                        </div>
                      </div>
                      <div className="indi-list">
                        <h3>Duration ++</h3>
                        <ul className="indi-ul">
                          <li>24 questions – 10 minutes. </li>
                        </ul>
                      </div>

                      <div className="indi-list">
                        <h3 className="bg-success">Results</h3>
                        <ul className="indi-ul">
                          <li>Motivations and Values that suit the position</li>
                          <li>Motivation and Values of the candidate</li>
                          <li>
                            Matching of motivations and matching of values.
                          </li>
                        </ul>
                      </div>

                      <div className="indi-list">
                        <h3 className="bg-secondary">Help :</h3>
                        <ul className="indi-ul">
                          <li>
                            Define motivations and values expected to the
                            position.
                          </li>
                          <li>
                            Discover the motivations and values of the
                            candidate.
                          </li>
                          <li>
                            Secure decision od recruitemnt and help for
                            interview.{" "}
                          </li>
                        </ul>
                      </div>
                      <div className="indi-list">
                        <h3 className="">Start Your Test </h3>
                        <div className="about-text">
                          <p>
                            It is a long established fact that a reader will be
                            distracted by the readable content of a page when
                            looking at its layout. The point of using Lorem
                            Ipsum is that it has a more-or-less normal
                            distribution of letters, as opposed to using
                            'Content here, content here', making it look like
                            readable English.
                          </p>
                        </div>
                        <div
                          className="add-width intro_layer mt-5 d-flex"
                          data-animation="fadeIn"
                        >
                          <div className="d-inline-block w-50">
                            <p>
                              <button
                                type="button"
                                className="btn bg-secondary center-block"
                                onClick={this.openRecruitmentExamples.bind(
                                  this
                                )}
                                style={{
                                  backgroundColor: "#191970",
                                  color: "white",
                                }}
                              >
                                See example of results
                              </button>
                            </p>
                          </div>
                          <div className="d-inline-block w-50">
                            <button
                              type="button"
                              className="btn  center-block example_button_radius"
                              onClick={this.openRecruitment.bind(this)}
                              style={{
                                backgroundColor: "#1ca9c9",
                                color: "white",
                              }}
                            >
                              START RECRUITMENT Test
                            </button>
                          </div>
                          <div className="d-inline-block w-50">
                            <p>
                              <button
                                class="btn btn-warning"
                                style={{
                                  backgroundColor: "#191970",
                                  color: "white",
                                }}
                                onClick={this.buyNowTest.bind(this)}
                              >
                                <FormattedMessage
                                  id="buynow"
                                  defaultMessage="Buy Now"
                                />
                              </button>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.happiness.price"
                          defaultMessage="<h3 class=''>Price </h3>"
                        />
                        <ul className="indi-ul">
                          <li>€ 15"</li>
                        </ul>
                        <div className="row">
                          <div className="col-md-4 col-sm-4 m-auto w100_991">
                            <div className="card text-center mt-4">
                              <div className="card-body">
                                <h4 className="card-title">
                                  <del>€ 15"</del>
                                </h4>
                                <p className="card-text">
                                  <i>ENTERPRISE TOOL©</i>
                                </p>
                                <p className="card-text">(Matching)</p>
                                <button className="btn btn-warning">
                                  <FormattedMessage
                                    id="hr.sale.force.week.trial"
                                    defaultMessage="FREE ON WEEK TRIAL"
                                  />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-4 col-sm-4 mt-4">
                            <div className="card text-center">
                              <div className="card-body">
                                <h4 className="card-title">€ 67.50</h4>
                                <p className="card-text">5 credits</p>
                                <p className="card-text">(-10%)</p>
                                {/*<Link className="btn btn-light btn-ligh-blue" to="/buy-test">*/}
                                <button
                                  class="btn btn-light btn-ligh-blue"
                                  onClick={this.buyNowTest.bind(this)}
                                >
                                  <FormattedMessage
                                    id="buynow"
                                    defaultMessage="Buy Now"
                                  />
                                </button>
                                {/*</Link>*/}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4 col-sm-4 mt-4">
                            <div className="card text-center">
                              <div className="card-body">
                                <h4 className="card-title">€ 99</h4>
                                <p className="card-text">10 credits</p>
                                <p className="card-text">(-33%)</p>
                                {/*<Link className="btn btn-light btn-ligh-blue" to="/buy-test">*/}
                                <button
                                  class="btn btn-light btn-ligh-blue"
                                  onClick={this.buyNowTest.bind(this)}
                                >
                                  <FormattedMessage
                                    id="buynow"
                                    defaultMessage="Buy Now"
                                  />
                                </button>
                                {/*</Link>*/}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4 col-sm-4 mt-4">
                            <div className="card text-center">
                              <div className="card-body">
                                <h4 className="card-title">€ 450</h4>
                                <p className="card-text">50 credits</p>
                                <p className="card-text">(-40%)</p>
                                {/*<Link className="btn btn-light btn-ligh-blue" to="/buy-test">*/}
                                <button
                                  class="btn btn-light btn-ligh-blue"
                                  onClick={this.buyNowTest.bind(this)}
                                >
                                  <FormattedMessage
                                    id="buynow"
                                    defaultMessage="Buy Now"
                                  />
                                </button>
                                {/*</Link>*/}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade pilotModal" id="RECRUITMENT">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h4 className="modal-title text-center text-uppercase w-100 medium  text-white font-20">
                  RECRUITMENT TOOL
                </h4>
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
              </div>

              <div className="modal-body">
                <div className="col-md-12">
                  <div className="about" id="services">
                    <div className="container text-justify">
                      <div
                        className="col-sm-12 col-md-12 animate animated slideInLeft"
                        data-animation="slideInLeft"
                      >
                        <h2 className="about-title text-left">
                          <FormattedHTMLMessage
                            id="hr.recruitment.popup.title"
                            defaultMessage="RECRUITMENT TOOL"
                          />
                        </h2>
                      </div>
                      <div
                        className="add-width intro_layer mt-5 d-flex"
                        data-animation="fadeIn"
                      >
                        <div className="d-flex m-auto w-100">
                          <div className="d-inline-block w-50">
                            <button
                              type="button"
                              className="btn btn-warning center-block example_button_radius"
                              onClick={this.openRecruitmentExamples.bind(this)}
                              style={{
                                backgroundColor: "#191970",
                                color: "white",
                              }}
                            >
                              <FormattedHTMLMessage
                                id="hr.recruitment.btn.examples"
                                defaultMessage="SEE EXAMPLE OF RESULTS"
                              />
                            </button>
                          </div>
                          <div className="d-inline-block w-50">
                            <p>
                              {localStorage.getItem("userRole") === "Enterprise" ? (
                                <button
                                  type="button"
                                  className="btn  center-block example_button_radius"
                                  onClick={this.openRecruitment.bind(this)}
                                  style={{
                                    backgroundColor: "#1ca9c9",
                                    color: "white",
                                  }}
                                >
                                  <FormattedHTMLMessage
                                    id="hr.recruitment.btn.hr.start"
                                    defaultMessage="JOB PROFILE"
                                  />
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  className="btn  center-block example_button_radius"
                                  onClick={this.openRecruitment.bind(this)}
                                  style={{
                                    backgroundColor: "#1ca9c9",
                                    color: "white",
                                  }}
                                >
                                  <FormattedHTMLMessage
                                    id="hr.recruitment.btn.candidate.start"
                                    defaultMessage="CANDIDATE ASSESSMENT"
                                  />
                                </button>
                              )}
                            </p>
                          </div>
                          <div className="d-inline-block w-50">
                            <p>
                              <button
                                class="btn btn-warning"
                                style={{
                                  backgroundColor: "#191970",
                                  color: "white",
                                }}
                                onClick={this.buyNowTest.bind(this)}
                              >
                                <FormattedMessage
                                  id="buynow"
                                  defaultMessage="Buy Now"
                                />
                              </button>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="hr.recruitment.p.duration"
                          defaultMessage="<h3>Duration</h3><ul className='indi-ul'> <li>24 questions – 10 minutes.</li></ul>"
                        />
                        {/* <h3>Duration </h3>
                      <ul className="indi-ul">
                        <li>24 questions – 10 minutes. </li>
                      </ul> */}
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="hr.recruitment.p.resultlist"
                          defaultMessage="<h3 className='bg-success'>Results</h3> <ul className='indi-ul'> <li>Motivations and Values that suit the position</li><li>Motivation and Values of the candidate</li><li>Matching of motivations and matching of values.</li></ul>"
                        />
                        {/* <h3 className="">Results </h3>
                      <ul className="indi-ul">
                        <li>Motivations and Values that suit the position </li>
                        <li>Motivation and Values of the candidate</li>
                        <li>Matching of motivations and matching of values.</li>
                      </ul> */}
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="hr.recruitment.p.help"
                          defaultMessage="<h3 className='bg-secondary'>Help :</h3> <ul className='indi-ul'> <li> Define motivations and values expected to the position. </li><li> Discover the motivations and values of the candidate. </li><li> Secure decision od recruitemnt and help for interview.</li></ul>"
                        />
                        {/* <h3 className="">Help </h3>
                      <ul className="indi-ul">
                        <li>
                          Define motivations and values expected to the
                          position.
                        </li>
                        <li>
                          Discover the motivations and values of the candidate.
                        </li>
                        <li>
                          Secure decision od recruitemnt and help for interview.
                        </li>
                      </ul> */}
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="hr.recruitment.p.start.test"
                          defaultMessage="<h3 class=''>Start Your Test </h3> <div className='about-text'> <p> It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. </p>"
                        />
                        {/* <h3 className="">Start Your Test </h3>
                        <div className="about-text">
                        <p>
                          Before starting ‘RECRUITMENT TOOL’ you can see an
                          example of results exactly as you will get after
                          taking. Your test still totally confidential and we
                          don’t use any named data coming from you for other
                          destination of the test (French Data Authority
                          n°661001){" "}
                        </p>
                      </div>*/}
                        <div
                          className="add-width intro_layer mt-5 d-flex"
                          data-animation="fadeIn"
                        >
                          <div className="d-flex m-auto w-100">
                            <div className="d-inline-block w-50">
                              <button
                                type="button"
                                className="btn btn-warning center-block example_button_radius"
                                onClick={this.openRecruitmentExamples.bind(
                                  this
                                )}
                                style={{
                                  backgroundColor: "#191970",
                                  color: "white",
                                }}
                              >
                                <FormattedHTMLMessage
                                  id="hr.recruitment.btn.examples"
                                  defaultMessage="SEE EXAMPLE OF RESULTS"
                                />
                              </button>
                            </div>
                            <div className="d-inline-block w-50">
                              <p>
                                {localStorage.getItem("userRole") === "Hr" ? (
                                  <button
                                    type="button"
                                    className="btn  center-block example_button_radius"
                                    onClick={this.openRecruitment.bind(this)}
                                    style={{
                                      backgroundColor: "#1ca9c9",
                                      color: "white",
                                    }}
                                  >
                                    <FormattedHTMLMessage
                                      id="hr.recruitment.btn.hr.start"
                                      defaultMessage="JOB PROFILE"
                                    />
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    className="btn center-block example_button_radius"
                                    onClick={this.openRecruitment.bind(this)}
                                    style={{
                                      backgroundColor: "#1ca9c9",
                                      color: "white",
                                    }}
                                  >
                                    <FormattedHTMLMessage
                                      id="hr.recruitment.btn.candidate.start"
                                      defaultMessage="CANDIDATE ASSESSMENT"
                                    />
                                  </button>
                                )}
                              </p>
                            </div>
                            <div className="d-inline-block w-50">
                              <p>
                                <button
                                  class="btn btn-warning"
                                  style={{
                                    backgroundColor: "#191970",
                                    color: "white",
                                  }}
                                  onClick={this.buyNowTest.bind(this)}
                                >
                                  <FormattedMessage
                                    id="buynow"
                                    defaultMessage="Buy Now"
                                  />
                                </button>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="indi-list">
                        <h3 className="">
                          <FormattedMessage
                            id="price"
                            defaultMessage="Price "
                          />
                        </h3>
                        {/* <ul className="indi-ul">
                        <li>
                          <FormattedHTMLMessage id="hr.recruitment.price" defaultMessage="€ 30 RECRUITMENT TOOL© (or 2 credits)"/>
                        </li>
                      </ul> */}
                        <div className="row">
                          <div className="col-md-12 col-sm-12 m-auto w100_991">
                            <div
                              className="card text-center mt-4"
                              style={{ border: "none" }}
                            >
                              {/* <div className="card-body">
                              <h4 className="card-title">
                                <del><FormattedMessage id="hr.recruitment.single.price" defaultMessage="€ 10"/></del>
                              </h4>
                              <p className="card-text"><i>RECRUITMENT TOOL©</i></p> */}
                              {/* <p className="card-text"><FormattedHTMLMessage id="hr.recruitment.price.credits" defaultMessage="(or 2 credits)"/></p> */}
                              {/* <button className="btn btn-warning">
                                  <Link target="_blank" to="/contact-professional">
                                    <FormattedMessage id="ask.free.trial" defaultMessage="ASK FOR FREE CREDIT"/>
                                  </Link>
                              </button> */}
                              {/* <button className="btn btn-warning" style={{backgroundColor:"#808080 "}}>
                                  <Link target="_blank" style={{color:"white"}} to="/contact-professional">
                                    <FormattedMessage id="ask.free.tria2" defaultMessage="ASK FOR FREE CREDIT"/>
                                  </Link>
                                </button> */}
                              {/* <span><b style={{color:"#000", fontSize:"20px"}}><FormattedMessage id="ask.free.tria2" defaultMessage="ASK FOR FREE CREDIT"/></b></span>  */}

                              {/* </div> */}
                            </div>
                          </div>
                        </div>

                        <center>
                          <FormattedHTMLMessage
                            id="hr.license"
                            defaultMessage=""
                          />
                        </center>
                      </div>
                      <div>
                        <FormattedHTMLMessage
                          id="hr.pice.detail1"
                          defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade pilotModal"
          id="myModal"
        // data-backdrop="static"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h4 className="modal-title text-center text-uppercase w-100 medium text-white font-20">
                  <FormattedMessage
                    id="result.example.title"
                    defaultMessage="Example of Results"
                  />
                </h4>
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
              </div>
              <div className="modal-body">
                {/* <h5 className="text-center mb-4" id="exampleResultTitle">Happiness Test Results</h5>                 */}
                <img
                  src="assets/images/happinessResult.png"
                  className="img-fluid w-100"
                  id="testResultData"
                  alt="happiness Result"
                />
                <div className="d-table m-auto">
                  <div className="d-inline-block" id="startButton"></div>
                </div>
                {/* <div className="text-center p-0 small">
                    <p> © Copyright 5W PILOT RH SOLUTIONS {CopyrightDate.getFullYear()} – All right reserved – www.pilotrhsolutions.com.</p>
                </div>                 */}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="modal fade pilotModal"  id="hrContactUs"  data-backdrop="static">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h4 className="modal-title text-center text-uppercase w-100 medium text-white font-20">
                  Leave Your Email
                </h4>
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
              </div>

              <div className="modal-body">
                <div className="col-md-12">
                  <div className="about" id="services">
                    <div className="container">
                      <div
                        className="col-sm-12 col-md-12 animate animated slideInLeft"
                        data-animation="slideInLeft"
                      >
                        <form>
                          <div className="form-group row">
                              <input type="text" readOnly="readonly" placeholder="yourEmail@gmail.com" className="form-control" id="staticEmail" required="required"/>
                          </div>
                          <div className="form-group row">
                            <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" placeholder="Your Message" required="required"></textarea>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            <div className="modal-footer">
             <button type="button" className="btn btn-default btn-primary" data-dismiss="modal">Cancle</button>
             <button type="button" className="btn btn-default btn-primary" data-dismiss="modal">Submit</button>
            </div>
            </div>
          </div>
        </div>          */}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isSignedIn: state.auth.isSignedIn,
    lang: state.locale.lang,
  };
};

talentCompy = connect(mapStateToProps, {})(talentCompy);

export default talentCompy;
